import { makeEnvironmentProviders } from '@angular/core';
import { ChatStore, PromptGeneratorService } from '@coin/chat-bot-data-access';
import { environment } from '@coin/shared/core/util-environments';
import { provideCopilotKit } from '@copilotkit/angular';
import { provideMarkdown } from 'ngx-markdown';

export function provideChatBot() {
  return makeEnvironmentProviders([
    provideMarkdown({}),
    ChatStore,
    PromptGeneratorService,
    // runtimeUrl is NOT set here to avoid an early /info request before the auth token
    // is available (causes 401 on fresh page loads via auth callback).
    // The ChatStore sets runtimeUrl lazily when the chat is first opened AND the token is ready.
    provideCopilotKit({
      licenseKey: environment.chatBot.licenseKey
    })
  ]);
}
